import React, { useState } from "react";
import PrimaryHeader from "../../../components/common/primaryHeader";
import UsersImg from "../../../assets/images/users.svg";
import User2Img from "../../../assets/images/user-one.svg";
import { TabView, TabPanel } from "primereact/tabview";
import AllResource from "./AllResource.jsx";
import { exportCSV, exportExcel, exportPdf } from "../../../utils/exportUtils";
import { API_ENDPOINTS } from "../../../utils/apiEndpoints";
import { commonPostApi } from "../../../utils/apiService.js";

const ResourceListReport = ({ role }) => {
  const [search, setSearch] = useState("");
  const [resourseDashboard, setResourceDashboard] = useState([]);
  const [columns, setColumns] = useState([]);
  const [values, setValues] = useState([]);
  const [navigatorState, setNavigatorState] = useState(null);

  function handleSearchChange(value) {
    setSearch(value);
  }

const fetchAllResourceReportList = async () => {
  if (!navigatorState?.app_role_id) {
    console.warn("Navigator not ready yet");
    return [];
  }

  const exportObj = {
    page: 1,
    limit: navigatorState.totalRecords || 10,
    sortFields: navigatorState.sortFields
      ? navigatorState.sortFields
      : [[navigatorState.sortBy || "user_name", navigatorState.sortDir || "ASC"]],
    searchValue: search || "",
    app_role_id: navigatorState.app_role_id
  };

  const res = await commonPostApi(
    API_ENDPOINTS.CAMP_MANAGER_REPORT_RESOURCE,
    exportObj
  );

  return res?.data?.data?.rows || [];
};


  return (
    <>
      <div className="patients-main-container">
        <div className="p-4 mt-2 Patients__date-container patient-list-report-header">
          <PrimaryHeader
            searchHeaderLable={"Resources List"}
            isDownloadButton={true}
            exportCSV={async () =>{
              const allData = await fetchAllResourceReportList();
              exportCSV(allData, columns, "Resource_List");
            }}
            exportExcel={async () =>{
              const allData = await fetchAllResourceReportList();
              exportExcel(allData, columns, "Resource_List");
            }}
            exportPdf={async() =>{ 
              const allData = await fetchAllResourceReportList();
              exportPdf(allData, columns, "Resource_List");
            }}
            isSearchEnabled={true}
            value={values}
            placeholder={"Search Resources"}
            isCalenderEnabled={false}
            onChange={handleSearchChange}
          />
          <div className="Patients__card-container mt-2">
            <ul className="Patients__card-holder">
              {resourseDashboard?.map((role) => (
                <li key={role.app_role_id}>
                  <div className="card-left-sec">
                    <p className="card-title">{role.role_name}</p>
                    <p className="card-info">
                      <span className="total-count">{role.count}</span>
                    </p>
                  </div>
                  <div className="card-right-sec">
                    <span className="card-icon bg-one">
                      <img
                        src={
                          role.role_name === "total resources"
                            ? UsersImg
                            : User2Img
                        }
                        alt={role.role_name}
                      />
                    </span>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="Logistics__table-container">
        <div className="tab-view-sec">
          <TabView>
            {role.map((item) => (
              <TabPanel header={item.role_name} key={item.app_role_id}>
                <AllResource
                  api={API_ENDPOINTS.CAMP_MANAGER_REPORT_RESOURCE}
                  dashboardApi={
                    API_ENDPOINTS.CAMP_MANAGER_REPORT_RESOURCE_DASHBOARD
                  }
                  roleId={item.app_role_id}
                  search={search}
                  setResourceDashboard={setResourceDashboard}
                  parentSetProducts={setColumns}
                  parentSetValues={setValues}
                  parentSetNavigator={setNavigatorState}
                />
              </TabPanel>
            ))}
          </TabView>
        </div>
      </div>
    </>
  );
};

export default ResourceListReport;